'use client'

import { useState } from 'react'

import { redirect, useRouter, useSearchParams } from 'next/navigation'

import { CreatePageDescription } from '~/app/accounts/create/CreatePageDescription'
import {
  CreateAccountType,
  getLegacyCreateRedirect,
} from '~/app/accounts/create/createRoutes'
import { withAuthentication } from '~/components/auth/withAuthentication'
import { withOrgAccess } from '~/components/auth/withOrgAccess'
import {
  Button,
  PageLayout,
  RadioGroupInput,
} from '~/components/component-library'
import { ACCOUNTS_GUIDE_URL } from '~/constants/externalUrls'

const SelectAccountTypeInner = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const [accountType, setAccountType] = useState<CreateAccountType>('operating')

  const legacyRedirect = getLegacyCreateRedirect(searchParams)
  if (legacyRedirect) redirect(legacyRedirect)

  const nextPath = `/accounts/create/${accountType}`

  return (
    <PageLayout
      pageType="standard"
      title="Create an account"
      description={
        <CreatePageDescription
          text="An account is where assets are stored within a workspace. Each type serves a different purpose."
          docsUrl={ACCOUNTS_GUIDE_URL}
        />
      }
    >
      <RadioGroupInput
        label="Account type"
        value={accountType}
        onChange={(value) => setAccountType(value as CreateAccountType)}
        options={[
          {
            value: 'operating',
            label: 'Operating account',
            description:
              'Day-to-day shared, multisig account for people and agents',
          },
          {
            value: 'automation',
            label: 'Automation account',
            description:
              'Deposit address that swaps and sweeps funds as they arrive',
          },
          {
            value: 'card',
            label: 'Card account',
            description:
              'Watched Rain collateral address to monitor balance and spend',
          },
        ]}
      />
      <div className="flex w-full items-center justify-between">
        <Button variant="secondary" href={{ path: '/accounts' }}>
          Cancel
        </Button>
        <Button
          onClick={() => router.push(nextPath)}
          shortcut={{
            key: 'meta+enter',
            callback: () => router.push(nextPath),
          }}
        >
          Next
        </Button>
      </div>
    </PageLayout>
  )
}

export const SelectAccountType = withAuthentication(
  withOrgAccess(SelectAccountTypeInner, { requireOwner: true }),
)
